/**
 * Messages sent FROM the parent (FinSuite) TO this embedded app (Verity).
 */
export const PARENT_TO_EMBED_MESSAGES = {
  THEME_CHANGE: 'FINSUITE_THEME_CHANGE',
  NAVIGATE_HOME: 'FINSUITE_NAVIGATE_HOME',
  /** Commands the embedded app to navigate to a specific relative path (deep-link restore from
   *  the FinSuite URL hash). Payload: { path: string }. Generalization of NAVIGATE_HOME. */
  NAVIGATE_TO: 'FINSUITE_NAVIGATE_TO',
  SEARCH_QUERY: 'FINSUITE_SEARCH_QUERY',
  SEARCH_RESULT_CLICK: 'FINSUITE_SEARCH_RESULT_CLICK',
  SEARCH_ACTION: 'FINSUITE_SEARCH_ACTION',
} as const;

/**
 * Messages sent FROM this embedded app (Verity) TO the parent (FinSuite).
 */
export const EMBED_TO_PARENT_MESSAGES = {
  EMBED_READY: 'FINSUITE_EMBED_READY',
  /** Reports the app's current in-app path (relative: pathname+search+hash) so the parent can
   *  deep-link its external "open in new tab" link and reflect the path in its URL hash.
   *  Payload: { path: string }. Embed plumbing params (embed/source/userAlias/isDarkMode) are
   *  stripped before sending. */
  CURRENT_PATH: 'FINSUITE_CURRENT_PATH',
  SEARCH_CAPABILITIES: 'FINSUITE_SEARCH_CAPABILITIES',
  SEARCH_RESULTS: 'FINSUITE_SEARCH_RESULTS',
  SEARCH_ACTION_RESULT: 'FINSUITE_SEARCH_ACTION_RESULT',
  IFRAME_CLICK: 'FINSUITE_IFRAME_CLICK',
} as const;
